<!-- <app-header></app-header> -->
<div class="container">
    <div class="jumstart">
        <div class="roleplay-header-text">Get Started with recommended scenarios</div>
        <div class="roleplay-sub-header-text">jump start your training sessions with customized scenarios to practise and boost your confidence</div>
    </div>
    <div class="profile-container">       
        <div class="profile1">
            <div class="chat-bubble">
                    <div class="roleplay-scenario-card-heading-text">Protected PCI</div>
                    <div class="roleplay-scenario-card-sub-heading-text" (click)="createNewScenario()">Dr. Lucy Smith</div>
            </div>
        </div>
        <div class="profile2">
            <div class="chat-bubble">
                <div class="roleplay-scenario-card-heading-text"> AMI/CS</div>
                <div class="roleplay-scenario-card-sub-heading-text">Dr. Nathan Turner </div>
            </div>
        </div>
        <div class="profile3">
            <div class="chat-bubble">
                <div class="roleplay-scenario-card-heading-text">Protected PCI</div>
                <div class="roleplay-scenario-card-sub-heading-text">Dr. Simon Clarke</div>
            </div>
        </div>
    </div>
</div>

<div class="scenario-container">
    <div class="new-scenario">
        <div class="roleplay-header-text1">Create a new scenario for roleplay</div>
        <div class="roleplay-sub-header-text1">To create a new role-play scenario, begin by designing customized
            situations that simulate interactions with an imaginary customer (surgeon, cardiologist, etc) . Tailor these
            scenarios by incorporating specific elements, including the desired objectives of the interaction, the
            established relationship history, professional goals, perceived value in the product, concerns about the
            product, and the emotional state and attitude of the imaginary customer. The key is to carefully craft a
            scenario that aligns with the learning or training objectives providing an opportunity to practice and
            enhance your communication skills in handling diverse customer interactions
        </div>
        <button (click)="createNewScenario()">create new scenario</button>
    </div>
</div>

